import {
  UpdateTerminKalenderFormContent,
  useUpdateTerminKalenderForm,
} from '@/domain/termine/features/UpdateTerminkalender/shared';
import { UpdateTerminKalenderFormContext } from '@/domain/termine/features/UpdateTerminkalender/shared/UpdateTerminKalenderFormContext';
import { useTranslation } from 'react-i18next';

type UpdateTerminKalenderSheetFormProps = {
  form: ReturnType<typeof useUpdateTerminKalenderForm>;
  onSubmitSuccess: () => void;
};

export function UpdateTerminKalenderSheetForm({
  form,
  onSubmitSuccess,
}: UpdateTerminKalenderSheetFormProps) {
  const { t } = useTranslation();

  return (
    <UpdateTerminKalenderFormContext.Provider value={form}>
      <form.AppForm>
        <form
          className="flex flex-col flex-1 overflow-hidden"
          onSubmit={async (e) => {
            e.preventDefault();
            await form.handleSubmit();
            onSubmitSuccess();
          }}>
          <div className="flex-1 overflow-y-auto">
            <UpdateTerminKalenderFormContent />
          </div>
          <hr className="h-px bg-neutrals-300 border-0" />
          <div className="flex justify-end gap-2 py-4 px-6">
            <form.SubmitButton
              buttonText={t('domain.termine.form.fertig')}
              size="sm"
            />
          </div>
        </form>
      </form.AppForm>
    </UpdateTerminKalenderFormContext.Provider>
  );
}
